//お問い合わせ
$(function () {
  //チェックボックス その他が選ばれた時、その他のテキストエリアを活性化する。
  $(".js-check-disabled-trigger").on("change", function () {
    var trigger = $(this);
    var ancestor = $(".js-check-disabled");
    var textarea = $(".js-check-disabled-textarea");
    var input;
    if (trigger.data("disabled")) {
      input = $(this).closest(ancestor).find(textarea);
    } else {
      input = $(this).closest(ancestor).find(textarea);
    }

    if (trigger.prop("checked") == true && input.prop("disabled") == true) {
      input.prop("disabled", false);
    } else {
      input.prop("disabled", true);
    }
  });

  //ラジオボタンでenable_flagにtrueを入れた時、テキストエリアを非活性にする
  $(".js-radio-disabled-textarea-trigger").on("change", function () {
    var ancestor = $(".js-radio-disabled");
    var inputsToDesiredArea = $(".js-radio-disabled-textarea");
    var input;
    input = $(this).closest(ancestor).find(inputsToDesiredArea);

    console.log(input);
    if ($(this).data("enable_flag")) {
      input.prop("disabled", false);
    } else {
      input.prop("disabled", true);
    }
  });

  //ラジオボタン　法人の場合、法人の価格表、それ以外の場合個人・未開業の価格表を
  //表示する
  $(".js-disabled-trigger").on("change", function () {
    var disabledType = $(this).data("disabled");
    var isChecked = $(this).prop("checked");
    var toDisabled = $(".js-disabled-input");

    if (!isChecked) return;

    if (disabledType == "corporation") {
      $(".js-budget-corporation").show();
      $(".js-budget-other").hide();
      toDisabled.parents(".input-select-front").removeClass("is-disabled");
      toDisabled.prop("disabled", false);
    } else if (disabledType == "personal") {
      $(".js-budget-other").show();
      $(".js-budget-corporation").hide();
      toDisabled.parents(".input-select-front").addClass("is-disabled");
      toDisabled.prop("disabled", true);
    } else {
      $(".js-budget-other").show();
      $(".js-budget-corporation").show();
      toDisabled.parents(".input-select-front").addClass("is-disabled");
      toDisabled.prop("disabled", true);
    }
  });

  // バリデーションエラー等でその他のdisabledをチェックする
  // その他初期設定
  // 相談内容
  var messageOther = $(".js-check-disabled-trigger.message");
  var messageOtherTextarea = $(".js-check-disabled-textarea.message");
  if (messageOther.prop("checked") == true && messageOtherTextarea.prop("disabled") == true) {
    messageOtherTextarea.prop("disabled", false);
  }

  //　紹介を希望しない事務所
  var relatedOfficeFlag = $(".js-radio-disabled-textarea-trigger.office[data-enable_flag=true]");
  var relatedOfficeTextarea = $(".js-radio-disabled-textarea.office");
  if (relatedOfficeFlag.prop("checked")) {
    relatedOfficeTextarea.prop("disabled", false);
  }

  //　希望するエリア
  var areaOther = $(".js-check-disabled-trigger.area");
  var areaOtherTextarea = $(".js-check-disabled-textarea.area");

  if (areaOther.prop("checked") == true && areaOtherTextarea.prop("disabled") == true) {
    areaOtherTextarea.prop("disabled", false);
  }

  // 会計ソフト
  var softwareOther = $(".js-check-disabled-trigger.software");
  var softwareOtherTextarea = $(".js-check-disabled-textarea.software");

  if (softwareOther.prop("checked") == true && softwareOtherTextarea.prop("disabled") == true) {
    softwareOtherTextarea.prop("disabled", false);
  }
  // 事業形態「未開業」
  var business = $(".js-disabled-trigger.business[data-disabled=not_open]");
  var businessInputs = $(".js-disabled-input.business");
  if (business.prop("checked") == true) {
    businessInputs.each(function (i, e) {
      $(e).prop("disabled", true);
      $(e).parents(".input-select-front").addClass("is-disabled");
    });
    $(".js-budget-other").show();
    $(".js-budget-corporation").hide();
  }

  // 事業形態「個人事業主」
  var personalBusiness = $(".js-disabled-trigger.business[data-disabled=personal]");
  var personalInputs = $(".js-disabled-input.business");
  if (personalBusiness.prop("checked") == true) {
    personalInputs.each(function (i, e) {
      $(e).prop("disabled", true);
      $(e).parents(".input-select-front").addClass("is-disabled");
    });
    $(".js-budget-other").show();
    $(".js-budget-corporation").hide();
  }

  // 事業形態「法人」
  var personalBusiness = $(".js-disabled-trigger.business[data-disabled=corporation]");
  var personalInputs = $(".js-disabled-input.business");
  if (personalBusiness.prop("checked") == true) {
    $(".js-budget-corporation").show();
    $(".js-budget-other").hide();
  }

  $(".js-inquiry-offices-search").on("click", function () {
    var trigger = $(this);
    var url = trigger.data("url");
    // formを作成してmethod: patchでsubmit
    var form = $("<form></form>", {
      action: url,
      method: "post"
    });
    form.append($("<input />", { type: "hidden", name: "_method", value: "patch" }));

    form.append(
      $("<input />", {
        type: "hidden",
        name: "authenticity_token",
        value: $("meta[name='csrf-token']").attr("content")
      })
    );
    form.appendTo("body").submit();
  });
});
